import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { ReactDatePicker } from "sr/helpers/ui-components/ReactDatePicker";

type Props = {
  data: { start_date?: string };
  HandleDataProps: (payload: { start_date: string | null }) => void;
  externalErrorId?: string;
};

const RequirementStartDateChange = forwardRef(({ data, HandleDataProps, externalErrorId }: Props, ref) => {
  const [startDate, setStartDate] = useState<string | null>(null);
  const [errorId, setErrorId] = useState<string>("");

  useEffect(() => {
    if (data?.start_date) {
      setStartDate(data.start_date); 
    }
  }, [data?.start_date]);

  useEffect(() => {
    HandleDataProps({ start_date: startDate });
  }, [startDate, HandleDataProps]);

  useImperativeHandle(ref, () => ({
    validateData: () => {
      if (!startDate) {
        setErrorId('INPUT.VALIDATION.REQUIREMENT.STARTDATE');
        return false;
      }
      setErrorId("");
      return true;
    },
    submitForm: () => ({ start_date: startDate }),
  }));

  return (
    <div>
      <p className="pt-4 text-base">Start Date</p>
      <div className="relative max-w-xs mt-2">
        <ReactDatePicker
          InputDivClass="mt-2"
          selected={startDate}
          onChange={(val: string) => setStartDate(val)}
          minDate={new Date()}
          placeholderText="Select start date"
          error={externalErrorId || errorId}
        />
      </div>
    </div>
  );
});

export default RequirementStartDateChange;
